export default {
  data () {
    return {
      w: window,
      stickyDatas: {
        stickyHeadHeight: undefined,
        wrapperTableEl: undefined,
        tableHeight: 0,
        ticking: false
      },
      stickyStyles: {
        maxHeight: 'auto'
      }
    }
  },
  watch: {
    loading () {
      this.tickingSticky()
    }
  },
  methods: {
    calculsSticky () {
      if (document.querySelector('#columns-collapse')) {
        this.stickyDatas.stickyHeadHeight = document.querySelector('#columns-collapse').offsetTop // Hauteur des sticky (header, action columns)
        let wHeight = this.w.innerHeight
        let maxHeightTable = wHeight - this.stickyDatas.stickyHeadHeight
        maxHeightTable = (maxHeightTable > 0) ? maxHeightTable + 'px' : 'auto'
        this.stickyStyles.maxHeight = maxHeightTable
      }
    },
    initSticky (wrapperTableEl) {
      if (wrapperTableEl) {
        this.stickyDatas.wrapperTableEl = wrapperTableEl // Element du tableau
        this.stickyDatas.tableHeight = wrapperTableEl.offsetHeight // Hauteur du tablau

        if (!(wrapperTableEl === undefined || this.stickyDatas.tableHeight === 0)) {
          this.calculsSticky()
        }
        this.w.addEventListener('resize', this.calculsSticky)
      }
    },
    tickingSticky () {
      if (!this.stickyDatas.ticking) {
        this.w.requestAnimationFrame(() => {
          this.initSticky(this.$el.querySelector('.js-table-wrapper-thead-sticky'))
          this.$set(this.stickyDatas, 'ticking', false)
        })
        this.$set(this.stickyDatas, 'ticking', true)
      }
    },
    destroySticky () {
      this.w.removeEventListener('resize', this.calculsSticky)
      this.stickyStyles.maxHeight = 'auto'
    }
  },
  mounted () {
    this.tickingSticky()
  },
  destroyed () {
    this.destroySticky()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/TableHeaderStickyMixin.js